import classnames from "classnames";
import React from "react";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import styles from "./contact-us-rebound-solution.module.scss";

function ContactUsReboundSolution({ solution: { id, fields, hierarchyPosition }, className }) {
  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Question on Rebound</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          // buttonType={buttonType}
          solutionId={id}
          className={styles["standardSolution__contact-details"]}
          location={locationOnPage}
        />
      </div>
    </article>
  );
}

export default ContactUsReboundSolution;
